import { IRootStore } from '../state/stores/Root/RootStore';
import { ISessionStore } from '../state/stores/Session/Session';
import { ITreeNav } from '../state/stores/TreeNav/TreeNav';
import { createContext, useContext } from 'react';

interface IRootStoreExtended extends IRootStore {
  // recast to strong types for stores which have lost typing due to circular dependency issue
  treeNav: ITreeNav;
  session: ISessionStore;
}

/**
 * Create a context we can use to
 * - Provide access to our stores from our root component
 * - Consume stores in our screens (or other components, though it's
 *   preferable to just connect screens)
 */
const RootStoreContext = createContext<IRootStoreExtended>({} as IRootStoreExtended);

/**
 * The provider our root component will use to expose the root store
 */
export const RootStoreProvider = RootStoreContext.Provider;

/**
 * A hook that screens can use to gain access to our stores, with
 * `const { someStore, someOtherStore } = useStores()`,
 * or less likely: `const rootStore = useStores()`
 */
export const useStores = () => useContext(RootStoreContext);


